// import store from "../store";
export function interceptor(axios, store) {
  axios.interceptors.response.use(
    (resp) => resp,
    (error) => {
      console.log("ERROR", error.response);
      if (
        error.response &&
        error.response.data &&
        error.response.data.details &&
        error.response.data.details.message === "jwt expired"
      ) {
        store.dispatch({
          type: "REDIRECT_TO_LOGIN",
          payload: { authStatus: "unAuthorized" },
        });
      }
      return Promise.reject(error);
    }
  );
}
// common to app
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";

// dispached to petShop - apetShopReducer
export const SET_CURRENT_PETSHOP = "SET_CURRENT_PETSHOP"; // set current petshop
export const FETCH_PETSHOPS = "FETCH_PETSHOPS"; // get all petSho
export const CREATE_PETSHOP = "CREATE_PETSHOP"; // post petShop
export const UPDATE_PETSHOP = "UPDATE_PETSHOP"; // put petShop
export const DELETE_PETSHOP = "DELETE_PETSHOP"; // put petShop
export const FETCH_PETSHOPS_BY_EMAIL = "FETCH_PETSHOPS_BY_EMAIL"; // get petShop by email
export const ADD_LOGO = "ADD_LOGO"; //add logo
export const GET_PETSHOP_BY_DOMAIN = "GET_PETSHOP_BY_DOMAIN"; //get petshop by domain
export const CHECK_PETSHOP_N_USER = "CHECK_PETSHOP_N_USER"; //check petshop and user existance

// dispached to addAnimalType - addAnimalTypeReducer
export const FETCH_ANIMALS = "FETCH_ANIMALS"; // get all animalTypes
export const CREATE_ANIMAL = "CREATE_ANIMAL"; // post animalTypes
export const UPDATE_ANIMAL = "UPDATE_ANIMAL"; // put animalTypes
export const DELETE_ANIMAL = "DELETE_ANIMAL"; // put animalTypes
export const UPDATE_DEFAULT_ANIMAL = "UPDATE_DEFAULT_ANIMAL"; // update animalTypes

// dispached to addBreedType - addBreedTypeReducer
export const FETCH_BREEDS = "FETCH_BREEDS";
export const CREATE_BREED = "CREATE_BREED";
export const UPDATE_BREED = "UPDATE_BREED";
export const DELETE_BREEDS = "DELETE_BREEDS";
export const FETCH_BREEDS_BY_ANIMAL = "FETCH_BREEDS_BY_ANIMAL";
export const FETCH_BREED_INFO = "FETCH_BREED_INFO";
export const FETCH_UPDATED_BREED_BY_ID = "FETCH_UPDATED_BREED_BY_ID";

// dispatched to addBreedCategory -
export const CREATE_BREED_CATEGORY = "CREATE_BREED_CATEGORY";
export const UPDATE_BREED_CATEGORY = "UPDATE_BREED_CATEGORY";
export const DELETE_BREED_CATEGORY = "DELETE_BREED_CATEGORY";
export const FETCH_BREED_CATEGORIES = "FETCH_BREED_CATEGORIES";

// dispatched to addBreedAttribute -
export const CREATE_BREED_ATTRIBUTE = "CREATE_BREED_ATTRIBUTE";
export const UPDATE_BREED_ATTRIBUTE = "UPDATE_BREED_ATTRIBUTE";
export const DELETE_BREED_ATTRIBUTE = "DELETE_BREED_ATTRIBUTE";
export const FETCH_BREED_ATTRIBUTES = "FETCH_BREED_ATTRIBUTES";

// dispached to RegType - RegTypeReducer
export const FETCH_REGTYPES = "FETCH_REGTYPES"; // get all regTypes
export const CREATE_REGTYPE = "CREATE_REGTYPE"; // post regTypes
export const UPDATE_REGTYPE = "UPDATE_REGTYPE"; // put regTypes
export const DELETE_REGTYPE = "DELETE_REGTYPE"; // put regTypes
export const UPDATE_DEFAULT_REGTYPE = "UPDATE_DEFAULT_REGTYPE"; // update regTypes

// dispached to Administered - AdministeredReducer
export const FETCH_ADMINISTEREDS = "FETCH_ADMINISTEREDS"; // get all administereds
export const CREATE_ADMINISTERED = "CREATE_ADMINISTERED"; // post administered
export const UPDATE_ADMINISTEREDS = "UPDATE_ADMINISTEREDS"; // update administered
export const DELETE_ADMINISTEREDS = "DELETE_ADMINISTEREDS"; // delete administered

// dispached to MedicalRecords - medicalRecordsReducer
export const ADD_MEDICAL_RECORD = "ADD_MEDICAL_RECORD"; // post medical records
export const FETCH_MEDICAL_RECORDS = "FETCH_MEDICAL_RECORDS"; // get all medical records
export const FETCH_LEFT_MEDICAL_RECORDS = "FETCH_LEFT_MEDICAL_RECORDS"; // get all medical records who have not entered contracts
export const DELETE_MEDICAL_RECORDS = "DELETE_MEDICAL_RECORDS"; // delete medical records
export const SHOW_MEDICAL_RECORD = "SHOW_MEDICAL_RECORD"; // show medical record
export const ADD_AVATAR = "ADD_AVATAR"; // add avatar
export const ADD_MEDICATION = "ADD_MEDICATION"; // add medical record medication
export const DELETE_MEDICATION = "DELETE_MEDICATION"; // delete medical record medication
export const UPDATE_MEDICAL_RECORD = "UPDATE_MEDICAL_RECORD"; // update medical record
export const FETCH_CONTRACT_FROM_WOO_STORE = "FETCH_CONTRACT_FROM_WOO_STORE"; // fetch contract from task manager
export const ATTACH_MR_AVATAR = "ATTACH_MR_AVATAR"; // attach avatar of medical record
export const GET_TOTAL_MR_COUNT = "GET_TOTAL_MR_COUNT"; //get total medical record count
export const UPDATE_PRINT_MRECORD = "UPDATE_PRINT_MRECORD"; //update print contract id
export const CREATE_WOO_PET = "CREATE_WOO_PET"; //create pet at woocommerce store
export const FETCH_DELETED_MEDICAL_RECORDS = "FETCH_DELETED_MEDICAL_RECORDS"; //fetch deleted medical records
export const RECOVER_MEDICL_RECORDS = "RECOVER_MEDICL_RECORDS"; //recover deleted medical records
export const FETCH_BREEDERS_DELIVERY = "FETCH_BREEDERS_DELIVERY"; //fetch breeders delivery records
export const FETCH_BREEDERS_DELIVERY_BY_BREEDER_ID = "FETCH_BREEDERS_DELIVERY_BY_BREEDER_ID"; //fetch breeders delivery records
export const UPDATE_WOO_PAGE_STATUS = "UPDATE_WOO_PAGE_STATUS"; //update the woo page status of medical records
export const FIND_PET_BYID = "FIND_PET_BYID"; //find pet available or not
export const FETCH_WAYBILL_FOR_ALL_PETS = "FETCH_WAYBILL_FOR_ALL_PETS"; //get waybills given time period
export const BOOST_WOO_STORE_PROFILE = "BOOST_WOO_STORE_PROFILE"; // boost woo store profile
export const DELETE_PUPPY_VIDEO = "DELETE_PUPPY_VIDEO";
export const UPDATE_VIDEO_CALL_STATUS = "UPDATE_VIDEO_CALL_STATUS";
export const UPDATE_PIN_TO_TOP_QUEUE = "UPDATE_PIN_TO_TOP_QUEUE"; //update pin to top queue in woostore
export const DELETE_PROFILE_IMAGE = "DELETE_PROFILE_IMAGE"; //delete profile images
export const GET_LEADS_AVAILABLE_PETS = "GET_LEADS_AVAILABLE_PETS" //get available pets
export const FETCH_AVAILABLE_PUPPIES_TO_QUEUE = "FETCH_AVAILABLE_PUPPIES_TO_QUEUE" //fetch available puppies to queue
export const GET_AVAILABLE_PUPPIES_FROM_QUEUE = "GET_AVAILABLE_PUPPIES_FROM_QUEUE" //get available puppies from queue
export const GET_PET_NAMES_FROM_OPENAI = "GET_PET_NAMES_FROM_OPENAI" //get pet names
export const GET_PET_PERSONALITY_DESCRIPTION_FROM_OPENAI = "GET_PET_PERSONALITY_DESCRIPTION_FROM_OPENAI" //get puppy personality description
export const GET_PET_ZODIAC_PERSONALITY_DESCRIPTION_FROM_OPENAI = "GET_PET_ZODIAC_PERSONALITY_DESCRIPTION_FROM_OPENAI" //get puppy zodiac description
export const UPDATE_MEDICAL_RECORD_MULTIPLE_IDS = "UPDATE_MEDICAL_RECORD_MULTIPLE_IDS"; //update multiple record
export const UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS = "UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS" //global video call enable or disable
export const FETCH_MEDICAL_RECORDS_BY_AGE = "FETCH_MEDICAL_RECORDS_BY_AGE"; //Fetch medical records  by age

// dispached to AddTreatments - AddTreatments
export const FETCH_CALCULATIONS = "FETCH_CALCULATIONS";
export const CREATE_FORMULA = "CREATE_FORMULA";
export const CREATE_TREATMENT = "CREATE_TREATMENT";
export const FETCH_TREATMENT = "FETCH_TREATMENT";
export const DELETE_CALCULATORS = "DELETE_CALCULATORS";
export const DELETE_TREATMENTS = "DELETE_TREATMENTS";
export const SHOW_CALC = "SHOW_CALC";
export const SHOW_TREATMENT = "SHOW_TREATMENT";
export const FETCH_CALCULATIONS_BY_TYPE = "FETCH_CALCULATIONS_BY_TYPE";
export const UPDATE_CALCULATOR = "UPDATE_CALCULATOR";
export const TOTAL_ONGOING_TREATMENTS = "TOTAL_ONGOING_TREATMENTS";
export const TOTAL_PENDING_TREATMENTS = "TOTAL_PENDING_TREATMENTS";  
export const UPDATE_TREATMENT ="UPDATE_TREATMENT";

// dispatched to Contracts - contractsReducer
export const ADD_CONTRACT = "ADD_CONTRACT"; // post contracts
export const FETCH_CONTRACTS = "FETCH_CONTRACTS"; // get all contracts
export const DELETE_CONTRACT = "DELETE_CONTRACT"; // delete contract
export const SHOW_CONTRACT = "SHOW_CONTRACT"; // show contract
export const UPDATE_CONTRACT = "UPDATE_CONTRACT"; // update contract
export const DELETE_PAYMENT = "DELETE_PAYMENT"; // delete contract payment
export const ADD_PAYMENT = "ADD_PAYMENT"; // add contract payment
export const GET_TOTAL_CONTRACTS = "GET_TOTAL_CONTRACTS"; //get contracts total count
export const GET_CONTRACTS_INFO = "GET_CONTRACTS_INFO"; //get contracts info in current year with payments
export const UPDATE_PRINT_CONTRACT = "UPDATE_PRINT_CONTRACT"; //update print contract id
export const RESEND_EMAIL = "RESEND_EMAIL"; // resend email
export const GET_RECENT_MEDICAL_RECORDS = "GET_RECENT_MEDICAL_RECORDS"; //get recent available medical records
export const GET_LAST_WEEK_CONTRACTS_INFO = "GET_LAST_WEEK_CONTRACTS_INFO"; //get last week contracts
export const GET_LAST_MONTH_CONTRACTS_INFO = "GET_LAST_MONTH_CONTRACTS_INFO"; //get last month contracts
export const GET_CONTRACTS_VIA_CUSTOMER_STATE = "GET_CONTRACTS_VIA_CUSTOMER_STATE"; //get contracts via customer state
export const GET_PDF_7005_CONTRACTS_DATA = "GET_PDF_7005_CONTRACTS_DATA"; //get contract data
export const FETCH_CONTRACT_SHIPPERS = "FETCH_CONTRACT_SHIPPERS"; // get all contract shippers 
export const UPDATE_CONTRACT_SHIPPERS = "UPDATE_CONTRACT_SHIPPERS"; //update contract shippers
// dispached to Breeders - BreedersReducer
export const FETCH_BREEDERS = "FETCH_BREEDERS"; // get all breeders
export const ADD_SIGNATURE = "ADD_SIGNATURE"; //add signature
export const FETCH_BREEDERS_APPLICATIONS = "FETCH_BREEDERS_APPLICATIONS"; //Fetch breedera applications
export const CREATE_BREEDER_APPLICATION = "CREATE_BREEDER_APPLICATION"; // Create breeder application
export const GET_BREEDER_APPLICATION = "GET_BREEDER_APPLICATION"; // Get breeder application
export const CHANGE_APPROVAL_STATUS_BREEDER_APPLICATION = "CHANGE_APPROVAL_STATUS_BREEDER_APPLICATION"; // Change approval status

export const FETCH_BREEDS_CATEGORY = "FETCH_BREEDS_CATEGORY"; // get all breed category
export const FETCH_BREEDERS_VACCINE_DURATION = "FETCH_BREEDERS_VACCINE_DURATION"; // get all durations
export const FETCH_BREEDER_BY_ID = "FETCH_BREEDER_BY_ID"; // get breeders vaccine by breeder id
export const ADD_BREEDER = "ADD_BREEDER"; //add new breeder
export const FETCH_BREEDER_INFO = "FETCH_BREEDER_INFO"; // get breeder info
export const ADD_BREEDER_VACCINE = "ADD_BREEDER_VACCINE"; // create breeder vaccine
export const UPDATE_BREEDER = "UPDATE_BREEDER"; // update breeder
export const DELETE_BREEDER_VACCINE = "DELETE_BREEDER_VACCINE"; // delete breeder vaccine
export const CREATED_BREEDER_VACCINE = "CREATED_BREEDER_VACCINE"; // redux state created breeder vaccine
export const DELETE_BREEDER = "DELETE_BREEDER"; // breeder delete
export const FETCH_CURRENT_USER_SETTING = "FETCH_CURRENT_USER_SETTING";
export const BREEDERS_SEARCH_VIA_BREEDTYPE = "BREEDERS_SEARCH_VIA_BREEDTYPE"; //get breeders via breed type

// dispached to Users - UsersReducer
export const ACCESS_VERIFY = "ACCESS_VERIFY";
export const FETCH_ALL_ACCESS_REQUESTS = "FETCH_ALL_ACCESS_REQUESTS";
export const APPROVE_ACCESS_REQUEST = "APPROVE_ACCESS_REQUEST";
export const REJECT_ACCESS_REQUEST = "REJECT_ACCESS_REQUEST";
export const ON_REJECT_ACCESS_REQUEST = "ON_REJECT_ACCESS_REQUEST";
export const ON_APPROVE_ACCESS_REQUEST = "ON_APPROVE_ACCESS_REQUEST";
export const ON_RECEIVE_ACCESS_REQUEST = "ON_RECEIVE_ACCESS_REQUEST";

export const DELETE_USER = "DELETE_USER"; // post user
export const CREATE_USER = "CREATE_USER"; // post user
export const FETCH_USERS = "FETCH_USERS"; // get all users
export const FETCH_USER = "FETCH_USER"; // get user
export const TOGGLE_USER_STATUS = "TOGGLE_USER_STATUS"; //change user status
export const UPDATE_USER = "UPDATE_USER"; // update user
export const GET_CURRENT_USER = "GET_CURRENT_USER"; // get current user
export const ATTACH_AVATAR = "ATTACH_AVATAR"; // update avatar image
export const UPDATE_LOGIN_RECORD = "UPDATE_LOGIN_RECORD"; //user login record update
export const FETCH_USER_LOGINS = "FETCH_USER_LOGINS"; //fetch all user logins
// dispached to Customers - CustomerReducer
export const FETCH_CUSTOMERS = "FETCH_CUSTOMERS"; // get all customers
export const SEND_EMAIL_CUSTOMERS = "SEND_EMAIL_CUSTOMERS"; //send MR email to customer
export const FETCH_VERIFY_EMAIL = "FETCH_VERIFY_EMAIL"; // fetch verified emails from aws
export const DELETE_CUSTOMERS = "DELETE_CUSTOMERS"; // delete customer
export const FETCH_ZIPCODES = "FETCH_ZIPCODES"; //fetch zipcode links
export const CREATE_ZIPCODES = "CREATE_ZIPCODES"; //create zip code
export const UPDATE_ZIPCODES = "UPDATE_ZIPCODES"; // updates zip codes
export const DELETE_ZIPCODES = "DELETE_ZIPCODES"; //delete zip codes
export const FETCH_ABANDONED_CARTS = "FETCH_ABANDONED_CARTS"; //getAbanoedcarts data
export const SEND_MESSAGE_TO_ABANDON_CUSTOMERS = "SEND_MESSAGE_TO_ABANDON_CUSTOMERS"; //send message to abandon customers
export const SEND_MESSAGE_TO_ABANDON_CUSTOMERS_COUNT = "SEND_MESSAGE_TO_ABANDON_CUSTOMERS_COUNT"; //send message to abandon customers count
export const GET_ABANDON_CART_CUSTOMERS_VIA_MEDICAL_RECORD = "GET_ABANDON_CART_CUSTOMERS_VIA_MEDICAL_RECORD"; //get abandoned cart customers via medical record id
export const UPDATE_ABANDONED_CART_LEAD_INFO = "UPDATE_ABANDONED_CART_LEAD_INFO"; //update abandoned cart lead info
export const FETCH_LOYAL_CUSTOMERS = "FETCH_LOYAL_CUSTOMERS"; //fetch loyal customers
export const FETCH_CUSTOM_TIME_ABANDONEDCART = "FETCH_CUSTOM_TIME_ABANDONEDCART"; //fetch custom time abandoned carts


// dispached to contractTerms - contractTermsReducer
export const FETCH_C_TERMS = "FETCH_C_TERMS";
export const CREATE_C_TERM = "CREATE_C_TERM";
export const UPDATE_C_TERM = "UPDATE_C_TERM";
export const DELETE_C_TERM = "DELETE_C_TERM";

// dispached to howFindUs - howFindUsReducer

export const FETCH_HW_FIND_US = "FETCH_HW_FIND_US";
export const CREATE_HW_FIND_US = "CREATE_HW_FIND_US";
export const UPDATE_HW_FIND_US = "UPDATE_HW_FIND_US";
export const DELETE_HW_FIND_US = "DELETE_HW_FIND_US";
export const DELETE_M_HW_FIND_US = "DELETE_M_HW_FIND_US";

//dispatched to Config - ConfigReducer
export const FETCH_CONFIG = "FETCH_CONFIG";
export const CREATE_CONFIG = "CREATE_CONFIG";
export const UPDATE_CONFIG = "UPDATE_CONFIG";
export const DELETE_CONFIG = "DELETE_CONFIG";
export const DELETE_ALL_CONFIG = "DELETE_ALL_CONFIG";
export const SET_DEFAULT_CONFIG = "SET_DEFAULT_CONFIG";
export const UPDATE_HEADER = "UPDATE_HEADER"; //update header image
export const GET_CONFIG_BYNAME = "GET_CONFIG_BYNAME";
export const UPDATE_DASHBOARD_BANNER = "UPDATE_DASHBOARD_BANNER"; //update dashboard banners
export const GET_DROPBOX_AUTHORIZED_URL = "GET_DROPBOX_AUTHORIZED_URL"; //get drop box authorized

//dispatchd to Payment - PaymentReducer

export const ADD_CARD = "ADD_CARD";
export const GET_CARDS = "GET_CARDS";
export const SET_DEFAULT_CARD = "SET_DEFAULT_CARD";
export const CREATE_CARD_TOKEN = "CREATE_CARD_TOKEN";
export const REMOVE_CARD = "REMOVE_CARD";
export const GET_PLANS = "GET_PLANS";
export const CHANGE_PLAN = "CHANGE_PLAN";
export const GET_ACTIVE_SUBCRIPTION_PLAN = "GET_ACTIVE_SUBCRIPTION_PLAN";
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const RETRIVE_EVENTS = "RETRIVE_EVENTS";
export const GET_INVOICES = "GET_INVOICES";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const CAPTURE_WEB_HOOKS = "CAPTURE_WEB_HOOKS";
export const CHECK_PAYMENT_SOURCES_EXISTENCE = "CHECK_PAYMENT_SOURCES_EXISTENCE";

//dispatched to pet

//dispatched to payment types

export const FETCH_PAYMENT_TYPE = "FETCH_PAYMENT_TYPE";
export const CREATE_PAYMENT_TYPE = "CREATE_PAYMENT_TYPE";
export const UPDATE_PAYMENT_TYPE = "UPDATE_PAYMENT_TYPE";
export const DELETE_PAYMENT_TYPE = "DELETE_PAYMENT_TYPE";
export const DELETE_M_PAYMENT_TYPE = "DELETE_M_PAYMENT_TYPE";
export const UPDATE_TAX_RATE = "UPDATE_TAX_RATE";
export const CLEAR_ANIMAL_TYPE = "CLEAR_ANIMAL_TYPE";

export const PDF_GENERATOR_STATUS_CHANGE = "PDF_GENERATOR_STATUS_CHANGE";

//dispatched to Woo-store (petpos integration status) - WooStoreReducer
export const FETCH_PET_QUEUE_RECORDS = "FETCH_PET_QUEUE_RECORDS";
export const RETRY_FETCH_CONTRACT = "RETRY_FETCH_CONTRACT";

//dispatched to change log - ChangeLogReducer

export const CREATE_CHANGE_LOG = "CREATE_CHANGE_LOG";
export const UPDATE_CHANGE_LOG = "UPDATE_CHANGE_LOG";
export const DELETE_CHANGE_LOG = "DELETE_CHANGE_LOG";
export const FETCH_CHANGE_LOGS = "FETCH_CHANGE_LOGS";
export const FETCH_RECENT_CHANGE_LOGS = "FETCH_RECENT_CHANGE_LOGS";
export const GET_CHANGE_LOGS = "GET_CHANGE_LOGS";

export const CREATE_FOOD_TYPE = "CREATE_FOOD_TYPE";
export const UPDATE_FOOD_TYPE = "UPDATE_FOOD_TYPE";
export const DELETE_FOOD_TYPE = "DELETE_FOOD_TYPE";
export const FETCH_FOOD_TYPES = "FETCH_FOOD_TYPES";

// dispatched to notification manager - notificationManagerReducer
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const RESEND_NOTIFICATION = "RESEND_NOTIFICATION";
export const TEST_NOTIFICATION = "TEST_NOTIFICATION";
export const GET_REPLIES = "GET_REPLIES";
export const SET_REPLY_CUSTOMER_INFO = "SET_REPLY_CUSTOMER_INFO";
export const STOP_SEND_PROCESS = "STOP_SEND_PROCESS";
export const UNSUBSCRIBE_CUSTOMER = "UNSUBSCRIBE_CUSTOMER";
export const SUBSCRIBE_CUSTOMER = "SUBSCRIBE_CUSTOMER";
export const MARK_AS_READ = "MARK_AS_READ";
export const GET_CUSTOMERS_FOR_GRID = "GET_CUSTOMERS_FOR_GRID";
export const GET_NOTIFICATION_MESSAGES = "GET_NOTIFICATION_MESSAGES";
export const SEND_MESSAGES_TO_GRID = "SEND_MESSAGES_TO_GRID";
export const ADD_AUTO_UNSUBSCRIBE_KEYWORD = "ADD_AUTO_UNSUBSCRIBE_KEYWORD";
export const GET_AUTO_UNSUBSCRIBE_KEYWORDS = "GET_AUTO_UNSUBSCRIBE_KEYWORDS";
export const UPDATE_AUTO_UNSUBSCRIBE_KEYWORD = "UPDATE_AUTO_UNSUBSCRIBE_KEYWORD";
export const DELETE_AUTO_UNSUBSCRIBE_KEYWORD = "DELETE_AUTO_UNSUBSCRIBE_KEYWORD";

//dispatch to social media submission reducer
export const FETCH_SOCIAL_MEDIA_SUBMISSION = "FETCH_SOCIAL_MEDIA_SUBMISSION";
export const FETCH_SOCIAL_MEDIA_WINNERS = "FETCH_SOCIAL_MEDIA_WINNERS";

//dispatch to woo Location reducer
export const FETCH_ALL_WOO_LOCATION_PAGES = "FETCH_ALL_WOO_LOCATION_PAGES";
export const FETCH_SINGLE_WOO_LOCATION_PAGE = "FETCH_SINGLE_WOO_LOCATION_PAGE";
export const UPDATE_WOO_LOCATION_PAGE = "UPDATE_WOO_LOCATION_PAGE";
export const CREATE_WOO_LOCATION_PAGE = "CREATE_WOO_LOCATION_PAGE";
export const DELETE_WOO_LOCATION_PAGE = "DELETE_WOO_LOCATION_PAGE";
export const ADD_LOCATION_IMAGE = "ADD_LOCATION_IMAGE";
export const PUBLISH_LOCATION_PAGE = "PUBLISH_LOCATION_PAGE";
export const GENERATE_LOCATION_PAGE_CONTENTS_OPENAI = "GENERATE_LOCATION_PAGE_CONTENTS_OPENAI";

//dispatch to social media submission reducer

//dispatch to subscribe to pet reducer
export const FETCH_SUBSCRIBE_TO_PETS = "FETCH_SUBSCRIBE_TO_PETS";
export const FETCH_SUBSCRIBE_NOTIFICATIONS = "FETCH_SUBSCRIBE_NOTIFICATIONS";
export const FETCH_SUBSCRIBE_TO_PETS_BY_MRID = "FETCH_SUBSCRIBE_TO_PETS_BY_MRID";
export const DELETE_SUBSCRIBER = "DELETE_SUBSCRIBER";
export const SEND_PROMOCODE_TO_SUBSCRIBERS = "SEND_PROMOCODE_TO_SUBSCRIBERS";
export const FETCH_SUBSCRIBERS_TO_RECEIVE_PROMO = "FETCH_SUBSCRIBERS_TO_RECEIVE_PROMO";
export const FETCH_SUBSCRIBER_REPLIES = "FETCH_SUBSCRIBER_REPLIES";
export const FETCH_LEAD_SUBSCRIBED_CUSTOMERS_VIA_MEDICAL_RECORD_ID = "FETCH_LEAD_SUBSCRIBED_CUSTOMERS_VIA_MEDICAL_RECORD_ID";
export const UPDATE_SUBSCRIBED_TO_PET = "UPDATE_SUBSCRIBED_TO_PET";

//dispatch to video manager reducer
export const FETCH_VIDEO_MANAGER_QUEUE = "FETCH_VIDEO_MANAGER_QUEUE";
export const RETRY_VIDEO_MANAGER_QUEUE_ITEM = "RETRY_VIDEO_MANAGER_QUEUE_ITEM";

//dispatched to virtual visit requests - virtualVisitRequestReducer
export const FETCH_VIRTUAL_VISIT_REQUESTS = "FETCH_VIRTUAL_VISIT_REQUESTS";
export const UPDATE_VIRTUAL_VISIT_REQUEST_STATUS = "UPDATE_VIRTUAL_VISIT_REQUEST_STATUS";

//dispatch to quiz reducer
export const FETCH_QUIZ_WITH_ANSWERS = "FETCH_QUIZ_WITH_ANSWERS"; 
export const UPDATE_QUIZ = "UPDATE_QUIZ";
export const FETCH_BREED_QUIZ_FEATURES = "FETCH_BREED_QUIZ_FEATURES";
export const CREATE_BREED_QUIZ_FEATURES = "CREATE_BREED_QUIZ_FEATURES";
export const QUIZ_FEATURES_VIA_BREED = "QUIZ_FEATURES_VIA_BREED";
export const FETCH_AVAILABLE_QUIZ_BREED = "FETCH_AVAILABLE_QUIZ_BREED";
export const EDIT_BREED_QUIZ_FEATURES = "EDIT_BREED_QUIZ_FEATURES";
export const DELETE_BREED_QUIZ_FEATURES = " DELETE_BREED_QUIZ_FEATURES";
export const CREATE_BREED_QUIZ_FEATURES_FROM_FILE ="CREATE_BREED_QUIZ_FEATURES_FROM_FILE";
export const FETCH_AVAILABLE_PUPPIES_BASE_ON_QUIZ_ANSWERS ="FETCH_AVAILABLE_PUPPIES_BASE_ON_QUIZ_ANSWERS";

//sales dashboard
export const GET_MONTHLY_SALES_PROMOTION_CONTRACTS_INFO = "GET_MONTHLY_SALES_PROMOTION_CONTRACTS_INFO"; //get sales promotion data
export const GET_YEARLY_SALES_PROMOTION_CONTRACTS_INFO = "GET_YEARLY_SALES_PROMOTION_CONTRACTS_INFO"; //get yearly sales promotion data 
 
//breed sales dashboard
export const GET_YEARLY_BREED_SALES_CONTRACTS_INFO = "GET_YEARLY_BREED_SALES_CONTRACTS_INFO"; // get yearly breed sale promotion data
export const FETCH_BREED_DASHBOARD_AVAILABLE_BREEDS = "FETCH_BREED_DASHBOARD_AVAILABLE_BREEDS";
export const GET_BREED_COUNT_AVAILABLE_BREEDS_WITH_MINIMUM_QUANTITY = "GET_BREED_COUNT_AVAILABLE_BREEDS_WITH_MINIMUM_QUANTITY";